"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadcareImage = exports.MAX_PREVIEW_SIZE = exports.DEFAULT_PREVIEW_SIZE = void 0;
var _uploads = require("@prezly/uploads");
var _constants = require("../constants.cjs");
var _UploadcareGifVideo = require("./UploadcareGifVideo.cjs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MAX_PREVIEW_SIZE = exports.MAX_PREVIEW_SIZE = 3000;
var DEFAULT_PREVIEW_SIZE = exports.DEFAULT_PREVIEW_SIZE = 2048;
var UploadcareImage = exports.UploadcareImage = /*#__PURE__*/function () {
  function UploadcareImage(_ref) {
    var _this = this;
    var uuid = _ref.uuid,
      filename = _ref.filename,
      mimeType = _ref.mimeType,
      size = _ref.size,
      originalWidth = _ref.originalWidth,
      originalHeight = _ref.originalHeight,
      _ref$effects = _ref.effects,
      effects = _ref$effects === void 0 ? [] : _ref$effects,
      caption = _ref.caption;
    _classCallCheck(this, UploadcareImage);
    _defineProperty(this, _constants.UPLOADCARE_FILE_DATA_KEY, void 0);
    _defineProperty(this, "uuid", void 0);
    _defineProperty(this, "filename", void 0);
    _defineProperty(this, "mimeType", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "originalHeight", void 0);
    _defineProperty(this, "originalWidth", void 0);
    _defineProperty(this, "effects", void 0);
    _defineProperty(this, "isGif", function () {
      return _this.mimeType === 'image/gif';
    });
    _defineProperty(this, "format", function () {
      var imageFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
      return _this.withEffect("/format/".concat(imageFormat, "/"));
    });
    _defineProperty(this, "preview", function () {
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (_this.isGif()) {
        // Do not resize GIF otherwise it breaks the animation
        return _this;
      }
      if (width === null && height === null) {
        return _this.withEffect('/preview/');
      }
      var effectiveWidth = Math.min(Math.round(width || MAX_PREVIEW_SIZE), MAX_PREVIEW_SIZE);
      var effectiveHeight = Math.min(Math.round(height || MAX_PREVIEW_SIZE), MAX_PREVIEW_SIZE);
      return _this.withEffect("/preview/".concat(effectiveWidth, "x").concat(effectiveHeight, "/"));
    });
    _defineProperty(this, "resize", function () {
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (width == null && height === null) {
        throw new Error('At least one function argument has to be non-null');
      }
      if (_this.isGif()) {
        // Do not resize GIF otherwise it breaks the animation
        return _this;
      }
      if (width === null) {
        return _this.withEffect("/resize/x".concat(height, "/"));
      }
      if (height === null) {
        return _this.withEffect("/resize/".concat(width, "/"));
      }
      return _this.withEffect("/resize/".concat(width, "x").concat(height, "/"));
    });
    _defineProperty(this, "crop", function (width, height) {
      return _this.withEffect("/crop/".concat(width, "x").concat(height, "/"));
    });
    _defineProperty(this, "scaleCrop", function (width, height) {
      var center = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (center) {
        return _this.withEffect("/scale_crop/".concat(width, "x").concat(height, "/center/"));
      }
      return _this.withEffect("/scale_crop/".concat(width, "x").concat(height, "/"));
    });
    _defineProperty(this, "toGifVideo", function () {
      // The `gif2video` transformation is supported only for gifs,
      // otherwise the server responds with "400 Bad Request".
      if (!_this.isGif()) {
        throw new Error("You can only convert a GIF to video. Given: \"".concat(_this.mimeType, "\"."));
      }
      return new _UploadcareGifVideo.UploadcareGifVideo({
        uuid: _this.uuid,
        filename: _this.filename,
        mimeType: _this.mimeType,
        size: _this.size,
        width: _this.originalWidth,
        height: _this.originalHeight
      });
    });
    _defineProperty(this, "srcSet", function (width) {
      var doubleWidth = width * 2;
      var src1x = _this.resize(width).cdnUrl;
      var src2x = _this.resize(doubleWidth).cdnUrl;
      if (_this.width < doubleWidth) {
        return "".concat(src1x, " ").concat(width, "w");
      }
      return "".concat(src1x, " ").concat(width, "w, ").concat(src2x, " ").concat(doubleWidth, "w");
    });
    _defineProperty(this, "toPrezlyStoragePayload", function () {
      return {
        version: 2,
        uuid: _this.uuid,
        filename: _this.filename,
        mime_type: _this.mimeType,
        size: _this.size,
        original_width: _this.originalWidth,
        original_height: _this.originalHeight,
        effects: _this.effects
      };
    });
    _defineProperty(this, "withEffect", function (effect) {
      return new UploadcareImage({
        uuid: _this.uuid,
        filename: _this.filename,
        mimeType: _this.mimeType,
        size: _this.size,
        originalWidth: _this.originalWidth,
        originalHeight: _this.originalHeight,
        effects: [].concat(_toConsumableArray(_this.effects), [effect])
      });
    });
    this.uuid = uuid;
    this.filename = filename;
    this.mimeType = mimeType;
    this.size = size;
    this.originalWidth = originalWidth;
    this.originalHeight = originalHeight;
    this.effects = effects;
    if (caption !== undefined) {
      this[_constants.UPLOADCARE_FILE_DATA_KEY] = {
        caption: caption
      };
    }
  }
  return _createClass(UploadcareImage, [{
    key: "caption",
    get: function get() {
      var _this$UPLOADCARE_FILE;
      return (_this$UPLOADCARE_FILE = this[_constants.UPLOADCARE_FILE_DATA_KEY]) === null || _this$UPLOADCARE_FILE === void 0 ? void 0 : _this$UPLOADCARE_FILE.caption;
    }
  }, {
    key: "dimensions",
    get: function get() {
      var _dimensions = dimensions([this.originalWidth, this.originalHeight], this.effects),
        _dimensions2 = _slicedToArray(_dimensions, 2),
        width = _dimensions2[0],
        height = _dimensions2[1];
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "width",
    get: function get() {
      return this.dimensions.width;
    }
  }, {
    key: "height",
    get: function get() {
      return this.dimensions.height;
    }
  }, {
    key: "aspectRatio",
    get: function get() {
      var _this$dimensions = this.dimensions,
        width = _this$dimensions.width,
        height = _this$dimensions.height;
      return width / height;
    }
  }, {
    key: "cdnUrl",
    get: function get() {
      var cdnUrl = [_constants.UPLOADCARE_CDN_URL, this.uuid,
      // Prepend a dash only if effects exist.
      // It doesn't matter if there's a dash at the end of URL even if there are no effects,
      // but it looks cleaner without it.
      this.effects.length === 0 ? this.effects : [''].concat(_toConsumableArray(this.effects)).join('-')].join('/');
      return "".concat(cdnUrl).concat(encodeURIComponent(this.filename));
    }
  }, {
    key: "downloadUrl",
    get: function get() {
      var downloadUrl = [_constants.UPLOADCARE_CDN_URL, this.uuid, [''].concat(_toConsumableArray(this.effects), ['/inline/no/']).join('-')].join('/');
      return "".concat(downloadUrl).concat(encodeURIComponent(this.filename));
    }
  }], [{
    key: "createFromUploadcareWidgetPayload",
    value: function createFromUploadcareWidgetPayload(fileInfo, caption) {
      if (!fileInfo.originalImageInfo) {
        throw new Error('UploadcareImage was given a non-image FileInfo object');
      }
      return new UploadcareImage({
        effects: fileInfo.cdnUrlModifiers ? fileInfo.cdnUrlModifiers.split('-').slice(1) : [],
        filename: fileInfo.name,
        mimeType: fileInfo.mimeType,
        originalHeight: fileInfo.originalImageInfo.height,
        originalWidth: fileInfo.originalImageInfo.width,
        size: fileInfo.size,
        uuid: fileInfo.uuid,
        caption: caption
      });
    }
  }, {
    key: "createFromPrezlyStoragePayload",
    value: function createFromPrezlyStoragePayload(payload, caption) {
      return new UploadcareImage({
        effects: payload.effects || [],
        filename: payload.filename,
        mimeType: payload.mime_type,
        originalHeight: payload.original_height,
        originalWidth: payload.original_width,
        size: payload.size,
        uuid: payload.uuid,
        caption: caption
      });
    }
  }, {
    key: "isPrezlyStoragePayload",
    value: function isPrezlyStoragePayload(payload) {
      return (0, _uploads.isUploadedImage)(payload);
    }
  }]);
}();
function dimensions(_ref2, effects) {
  var _ref3 = _slicedToArray(_ref2, 2),
    width = _ref3[0],
    height = _ref3[1];
  return effects.reduce(function (_ref4, effect) {
    var _ref5 = _slicedToArray(_ref4, 2),
      w = _ref5[0],
      h = _ref5[1];
    var _effect$split = effect.split('/'),
      _effect$split2 = _slicedToArray(_effect$split, 3),
      _ = _effect$split2[0],
      name = _effect$split2[1],
      params = _effect$split2[2];
    switch (name) {
      case 'preview':
        {
          if (!params) {
            return fit([w, h], [DEFAULT_PREVIEW_SIZE, DEFAULT_PREVIEW_SIZE]);
          }
          var p = params.split('x');
          var px = parseInt(p[0], 10) || null;
          var py = parseInt(p[1], 10) || null;
          return fit([w, h], [px, py]);
        }
      case 'resize':
      case 'crop':
      case 'scale_crop':
        {
          var _p = params.split('x');
          var _px = parseInt(_p[0], 10) || null;
          var _py = parseInt(_p[1], 10) || null;
          return resize([w, h], [_px, _py]);
        }
    }
    return [w, h];
  }, [width, height]);
}
function fit(_ref6, _ref7) {
  var _ref8 = _slicedToArray(_ref6, 2),
    width = _ref8[0],
    height = _ref8[1];
  var _ref9 = _slicedToArray(_ref7, 2),
    maxWidth = _ref9[0],
    maxHeight = _ref9[1];
  var resizedWidth = width;
  var resizedHeight = height;
  if (maxWidth && maxWidth < resizedWidth) {
    resizedWidth = maxWidth;
    resizedHeight = Math.round(height * maxWidth / width);
  }
  if (maxHeight && maxHeight < resizedHeight) {
    resizedWidth = Math.round(width * maxHeight / height);
    resizedHeight = maxHeight;
  }
  return [resizedWidth, resizedHeight];
}
function resize(_ref10, _ref11) {
  var _ref12 = _slicedToArray(_ref10, 2),
    width = _ref12[0],
    height = _ref12[1];
  var _ref13 = _slicedToArray(_ref11, 2),
    maxWidth = _ref13[0],
    maxHeight = _ref13[1];
  if (maxWidth && maxHeight) {
    return [maxWidth, maxHeight];
  }
  if (maxWidth) {
    return [maxWidth, Math.round(height * maxWidth / width)];
  }
  if (maxHeight) {
    return [Math.round(width * maxHeight / height), maxHeight];
  }
  return [width, height];
}